<form>
  <spk-card title="Search Error Logs">
    <spk-search-grid #grid defaultSortProperty="Id DESC" list="ErrorLogSearchRow" [leftLinks]="leftLinks"></spk-search-grid>
  </spk-card>
</form>